import materialUI from "material-UI";
import styled from "styled-components";
import colors from "../../../../constants/color";

export const Container = styled.div`
  padding: 0 24px;
`;

export const LabelText = styled.span`
  display: flex;
  flex-direction: row;
  font-size: 14px;
  line-height: 150%;
  color: #333333;
  font-family: Inter-Medium;
  margin-bottom: 8px;

  p {
    color: red;
    margin-left: 4px;
  }
`;

export const ProdutosList = styled.div`
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 8px;
  margin-top: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${colors.LigthGrey};
    border-radius: 4px;
  }
`;

export const ProdutoItem = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f5f5f5;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const ProdutoInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 12px;
  flex: 1;
`;

export const ProdutoNome = styled.span`
  font-size: 14px;
  color: #333333;
  font-family: Inter;
  margin-bottom: 4px;
`;

export const ProdutoBandeira = styled.span`
  font-size: 12px;
  color: #666666;
  font-family: Inter;
`;

export const SpaceY: any = styled.div`
  height: ${(props: any) => props.space}px !important;
`;

export const Buttons = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 12px;
  width: 100%;

  button {
    padding: 8px;
    box-sizing: border-box;
    border-radius: 8px;
    font-size: 14px;
    cursor: pointer;
    font-weight: 500;
    height: 40px;
    :disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }
  }

  .primary {
    background-color: #2d5bff;
    color: white;
  }

  .secondary {
    background-color: transparent;
    color: #424248;
    outline: 1px solid #a3a3a6;
  }

  .disabled {
    opacity: 0.6 !important;
    cursor: not-allowed !important;
  }
`;
